import { __extends } from "tslib";
import Resource from './resource';
import Visit from '../models/visit';
var VisitsModule = (function (_super) {
    __extends(VisitsModule, _super);
    function VisitsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VisitsModule.prototype.create = function (data) {
        var _this = this;
        return this.client.http.post('/visits', data).then(function (_a) {
            var visit = _a.data.data;
            return new Visit(visit, _this.client);
        });
    };
    VisitsModule.prototype.fetchHistory = function () {
        var _this = this;
        return this.client.http.get('/visits').then(function (_a) {
            var visits = _a.data.data;
            return visits.map(function (visit) { return new Visit(visit, _this.client); });
        });
    };
    VisitsModule.prototype.fetch = function (visitId) {
        var _this = this;
        return this.client.http.get("/visits/" + visitId).then(function (_a) {
            var visit = _a.data.data;
            return new Visit(visit, _this.client);
        });
    };
    VisitsModule.prototype.fetchQuestionnaire = function (visitId) {
        return this.client.http
            .get("/visits/" + visitId + "/questionnaire")
            .then(function (_a) {
            var questionnaire = _a.data.data;
            return questionnaire;
        });
    };
    VisitsModule.prototype.fetchCoupons = function (visitId, treatmentPlanId) {
        var endpoint = treatmentPlanId
            ? "/visits/" + visitId + "/coupons?treatment_plan_id=" + treatmentPlanId
            : "/visits/" + visitId + "/coupons";
        return this.client.http.get(endpoint).then(function (_a) {
            var coupons = _a.data.data;
            return coupons;
        });
    };
    VisitsModule.prototype.updateMedicalHistory = function (visitId, body) {
        return this.client.http.post("/visits/" + visitId + "/medical-history", body).then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    return VisitsModule;
}(Resource));
export default VisitsModule;
//# sourceMappingURL=visits.js.map